/* eslint-disable camelcase */
import { fetchAll } from '@/api/orderType'

const state = {
  list: [],
  items: [],
}

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list
  },
  SET_ITEMS: (state, items) => {
    state.items = items
  },
}

const actions = {
  list({ commit }) {
    return new Promise((resolve, reject) => fetchAll()
      .then(response => {
        console.log('store list response', response)
        const { data } = response
        commit('SET_LIST', data.items)
        const items = []
        data.items.forEach(item => items.push({
          value: item.id,
          text: `${item.description}`,
        }))
        commit('SET_ITEMS', items)
        resolve(items)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)
      }))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
